import { render, staticRenderFns } from "./powerOfAttorney.vue?vue&type=template&id=21a872c8&scoped=true"
import script from "./powerOfAttorney.vue?vue&type=script&lang=js"
export * from "./powerOfAttorney.vue?vue&type=script&lang=js"
import style0 from "./powerOfAttorney.vue?vue&type=style&index=0&id=21a872c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a872c8",
  null
  
)

export default component.exports